import React from "react";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";

export default function CustomTimeline({data}) {
  return (
    <Timeline>
      {data.map((e,index) => {
        return (
            <TimelineItem>
              <TimelineSeparator>
                  <img width={30} height={30} src={e.icon} alt="timeline logo" />
              { index<data.length-1 && <TimelineConnector/>}
              </TimelineSeparator>
              <TimelineContent>{e.content}</TimelineContent>
            </TimelineItem>
        )
      })}
    </Timeline>
  );
}
